import { logger } from "@/utils/logger";

export const parseFormSubmissions = (content: string): any | null => {
  
  // Handle the new FORM_SUBMISSION format from formatFormSubmissionForChat
  const newFormSubmissionPattern = /^FORM_SUBMISSION:(.+)$/;
  const newFormMatch = newFormSubmissionPattern.exec(content.trim());
  logger.log('*** Form submission pattern match:', !!newFormMatch);
  
  if (newFormMatch) {
    logger.log('*** Found FORM_SUBMISSION pattern');
    try {
      const jsonString = newFormMatch[1].trim();
      logger.log('*** Extracted JSON string:', jsonString.substring(0, 100) + '...');
      if (!jsonString || jsonString === '') {
        logger.log('Empty JSON string in new form submission format');
        return null;
      }
      const parsedData = JSON.parse(jsonString);
      logger.log('*** Parsed form submission data:', parsedData);
      if (parsedData.type === 'form_submission' && parsedData.formData) {
        logger.log('*** Returning formatted form data');
        return {
          ...parsedData.formData,
          formType: parsedData.formType
        };
      }
    } catch (error) {
      console.error('Error parsing new form submission JSON:', error);
      return null;
    }
  }

  // Handle empty FORM_SUBMISSION cases
  if (content.trim() === 'FORM_SUBMISSION:') {
    logger.log('Empty FORM_SUBMISSION detected, returning null');
    return null;
  }
  
  // Check for legacy form submission JSON with improved error handling
  const formSubmissionPattern = /^Form submission:\s*(\{[\s\S]*\})$/;
  const formMatch = formSubmissionPattern.exec(content.trim());
  if (formMatch) {
    try {
      const jsonString = formMatch[1].trim();
      if (!jsonString || jsonString === '') {
        logger.log('Empty JSON string in legacy form submission');
        return null;
      }
      return JSON.parse(jsonString);
    } catch (error) {
      console.error('Error parsing legacy form submission JSON:', error);
      return null;
    }
  }

  // Check for offer form submission
  const offerFormPattern = /^Téléphone:\s*([^,]+),\s*Nom:\s*(.+)$/;
  const offerMatch = offerFormPattern.exec(content.trim());
  if (offerMatch) {
    return {
      phone: offerMatch[1].trim(),
      name: offerMatch[2].trim()
    };
  }

  // Check for appointment form submissions
  const appointmentFormPattern = /^Demande de rendez-vous soumise:\s*\n*\s*((?:Nom|Téléphone|Courriel|Date|Heure):[^\n]+(?:\n|$))+/;
  const appointmentMatch = appointmentFormPattern.exec(content.trim());
  if (appointmentMatch) {
    return parseAppointmentForm(appointmentMatch[1], 'fr');
  }

  // Check for English appointment form submissions
  const appointmentFormPatternEn = /^Appointment request submitted:\s*\n*\s*([\s\S]*?)(?=\n\n|$)/;
  const appointmentMatchEn = appointmentFormPatternEn.exec(content.trim());
  if (appointmentMatchEn) {
    return parseAppointmentForm(appointmentMatchEn[1], 'en');
  }

  return null;
};

const parseAppointmentForm = (formText: string, language: 'fr' | 'en'): any => {
  const formData: { [key: string]: string } = {};
  const lines = formText.split('\n').filter(line => line.trim());
  
  lines.forEach(line => {
    const colonIndex = line.indexOf(':');
    if (colonIndex !== -1) {
      const key = line.substring(0, colonIndex).trim();
      const value = line.substring(colonIndex + 1).trim();
      
      if (language === 'fr') {
        switch (key) {
          case 'Nom': formData.name = value; break;
          case 'Téléphone': formData.phone = value; break;
          case 'Courriel': formData.email = value; break;
          case 'Date': formData.date = value; break;
          case 'Heure': formData.time = value; break;
        }
      } else {
        switch (key) {
          case 'Name': formData.name = value; break;
          case 'Phone': formData.phone = value; break;
          case 'Email': formData.email = value; break;
          case 'Date':
          case 'Appointment Date': formData.date = value; break;
          case 'Time': formData.time = value; break;
        }
      }
    }
  });
  
  return formData;
};
